<template>
  <div class="person-center">
    <div class="person-center-content home_page">
      <el-header class="right-menu-name" height="38px"
        >{{ $t("route.myAccount") }} <i class="el-icon-arrow-right"></i>
        <span>{{ $route.meta.title }}</span></el-header
      >
      <el-container class="person-center-wrap">
        <el-aside width="160px" class="left-menu">
          <!-- 菜单列表 -->
          <div class="menu-tree">
            <div
              v-for="itemP in menuTree"
              :key="itemP.id"
              class="menu-tree-wrap"
            >
              <div v-show="itemP.showLeft" class="menu-tree-first">
                <Tooltips :innerContent="itemP.menuName" />
              </div>
              <div
                v-show="itemP.showLeft && item.showLeft"
                v-for="item in itemP.children"
                :key="item.menuId"
                class="menu-tree-item"
                @click="routerjump(item)"
              >
                <Tooltips :innerContent="item.menuName" />
              </div>
            </div>
          </div>
        </el-aside>
        <el-container>
          <el-main class="right-menu-content">
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>
<script>
import Tooltips from '@/components/tooltipShow'

export default {
  data () {
    return {}
  },
  components: {
    Tooltips
  },
  computed: {
    menuTree () {
      // 关闭知识培训相关功能
      return (this.$store.state.menuList || []).filter((item) => {
        return !['知识社区', '培训功能'].includes(item.menuName)
      })
    }
  },
  mounted () {
    if (this.menuTree.length === 0) {
      this.bus.$emit('getUserMenuPerm')
    }
  },
  methods: {
    routerjump (item) {
      if (item.menuUrl) {
        let com = this.$store.state.user.companyAccountInfo.find((item) => {
          return item.companyId === item.defaultCompanyId
        })
        if (item.menuUrl === 'organization' && com && com.resignFlag) {
          this.$confirm('你暂时没有企业', '认证提示', {
            confirmButtonText: '我知道了',
            showCancelButton: false,
            type: 'warning'
          })
            .then(() => {})
            .catch(() => {})
        } else if (item.menuUrl === 'forget') {
          this.$router.push({
            name: item.menuUrl,
            query: {
              type: 'modify'
            }
          })
        } else {
          this.$router.push({
            name: item.menuUrl
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.person-center {
  background: #f8f9fa;
  font-family: Alibaba PuHuiTi;

  .person-center-content {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0;

    .right-menu-name {
      padding: 8px 16px;
      color: #999;
      font-weight: bold;

      i {
        margin: 0 3px;
        color: #666;
      }

      span {
        color: #333;
      }
    }

    .person-center-wrap {
      background-color: #fff;
      border-radius: 8px;

      .left-menu {
        position: relative;

        &::after {
          content: "";
          position: absolute;
          right: 0;
          top: 20px;
          background: rgba(42, 84, 209, 0.5);
          height: calc(100% - 40px);
          width: 1px;
        }

        .menu-tree {
          padding: 30px 22px 30px;
          line-height: 22px;

          .menu-tree-wrap {
            margin-bottom: 10px;

            &:last-child {
              margin-bottom: 0;
            }

            .menu-tree-first {
              font-weight: bold;
              color: #333;
              font-size: 14px;
              line-height: 24px;
            }

            .menu-tree-item {
              font-size: 12px;
              color: #999;
              line-height: 22px;
              cursor: pointer;
            }
          }
        }
      }
      .right-menu-content {
        padding: 30px;
      }
    }
  }

  /deep/ .el-table__row .cell {
    font-size: 12px;
  }
}
</style>
